module.exports = __webpack_public_path__ + "static/img/6.320d37c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/6.png
// module id = mkP7
// module chunks = 0